import { api } from '../../api/api';
import { apis } from '../../config';
import { util } from '../../api/util/index';
export default class FileManageDb {
    constructor() {
        this.dbName = 'fileop';
        this.fileTable = 'file';
        this.importMailTable = 'import_mail';
        this.dbApi = api.requireLogicalApi(apis.dbInterfaceApiImpl);
    }
    put(file) {
        const time = new Date().getTime();
        const data = this.mapFileAttachModelToObject(file, time);
        return this.dbApi
            .put({
            dbName: this.dbName,
            tableName: this.fileTable,
            _dbAccount: file === null || file === void 0 ? void 0 : file._account,
        }, data)
            .then((result) => {
            const res = result.__prKey__;
            if (util.isNumber(res))
                file.fid = Number(res);
            return file;
        });
    }
    get(key, type, _account = '') {
        return this.dbApi
            .getByEqCondition({
            dbName: this.dbName,
            tableName: this.fileTable,
            query: { [type]: key },
            _dbAccount: _account,
        }, _account)
            .then((re) => re
            .sort((a, b) => {
            if (a === null || a === void 0 ? void 0 : a.fid) {
                return (b === null || b === void 0 ? void 0 : b.fid) ? -(Number(a.fid) - Number(b.fid)) : -1;
            }
            return (b === null || b === void 0 ? void 0 : b.fid) ? 1 : 0;
        })
            .map(it => this.mapObjectToFileAttachModel(it)));
    }
    del(fid, _account = '') {
        return this.dbApi.deleteById({
            dbName: this.dbName,
            tableName: this.fileTable,
            _dbAccount: _account,
        }, fid);
    }
    delBatch(items) {
        if (!items || items.length === 0)
            return;
        setTimeout(() => {
            var _a;
            const fids = items
                .map(it => {
                if (it.filePath && window.electronLib.fsManage.isExist(it.filePath))
                    return undefined;
                return it.fid;
            })
                .filter(it => !!it);
            this.dbApi
                .deleteById({
                dbName: this.dbName,
                tableName: this.fileTable,
                _dbAccount: (_a = items[0]) === null || _a === void 0 ? void 0 : _a._account,
            }, fids)
                .then();
        }, 10);
    }
    putImportMails(mailInfo, _account) {
        const time = new Date().getTime();
        const data = this.mapImportMailsModelToObj(mailInfo, time);
        return this.dbApi.putAll({
            dbName: this.dbName,
            tableName: this.importMailTable,
            _dbAccount: _account,
        }, data);
    }
    getImportMailByMd5(md5List, _account) {
        return this.dbApi
            .getByIds({
            dbName: this.dbName,
            tableName: this.importMailTable,
            _dbAccount: _account,
        }, md5List)
            .then((res) => {
            res = res.length ? res.filter(item => item !== undefined) : [];
            if (res.length) {
                return this.mapObjToImportMailsModel(res);
            }
            return [];
        });
    }
    mapImportMailsModelToObj(mailInfos, time) {
        return mailInfos.map(info => ({
            mailMd5: info.mailMd5,
            mid: info.mid,
            mailLocalPath: info.mailLocalPath,
            createTime: time,
        }));
    }
    mapObjToImportMailsModel(mailInfos) {
        return mailInfos.map(info => ({
            mailMd5: info.mailMd5,
            mid: info.mid,
            mailLocalPath: info.mailLocalPath,
            createTime: info.createTime,
        }));
    }
    mapFileAttachModelToObject(file, time) {
        const data = {
            fid: file.fid,
            fileName: file.fileName,
            fileMd5: file.fileMd5,
            fileSize: file.fileSize,
            fileType: file.fileType,
            filePath: file.filePath,
            fileUrl: file.fileUrl,
            fileOriginUrl: file.fileOriginUrl || file.fileUrl || '_',
            fileSourceType: file.fileSourceType,
            fileSourceKey: file.fileSourceKey,
            fileStatus: file.fileStatus,
            createTime: time,
        };
        return data;
    }
    mapObjectToFileAttachModel(it) {
        return {
            fid: it.fid,
            fileName: it.fileName,
            fileMd5: it.fileMd5,
            fileSize: it.fileSize,
            fileType: it.fileType,
            filePath: it.filePath,
            fileUrl: it.fileUrl,
            fileSourceType: it.fileSourceType,
            fileSourceKey: it.fileSourceKey,
            fileStatus: it.fileStatus,
            fileRecorderTime: it.createTime,
        };
    }
    init() {
        this.dbApi.initDb(this.dbName);
    }
    close() {
        this.dbApi.closeSpecific(this.dbName);
    }
}
